type AuthSessionInvalidationHandler = () => void;

let invalidationHandler: AuthSessionInvalidationHandler | null = null;

export function registerAuthSessionInvalidationHandler(
  handler: AuthSessionInvalidationHandler,
): () => void {
  invalidationHandler = handler;
  return () => {
    if (invalidationHandler === handler) {
      invalidationHandler = null;
    }
  };
}

export function invalidateAuthSession(): void {
  invalidationHandler?.();
}
